<template>
  <div>
    <div class="line-three">
      <div class="flex three-class">
        <div class="icon-circle flex-x-y-center">
          <div class="iconfont icon-xuanzhuanshouji icons"></div>
        </div>
        <div>
          <div class="my-pro">备用密保手机</div>
          <!-- 如果没有绑定提示未设置否则 -->
          <div class="id" v-if="!userInfo.sparemobile || userInfo.sparemobile == 0">
            还未设置
            <span class="tip"
              >防止手机号停用或者暂时接收不到验证短信，强烈建议设置，便于忘记密码时重置</span
            >
          </div>
          <div class="id" v-else>
            已设置： {{ userInfo.sparemobile }}
          </div>
        </div>
        <div class="flex-1" v-show="!userInfo.sparemobile">
          <div class="flex-end change-password" @click="spareEncrypted()">
            绑定
          </div>
        </div>
      </div>
    </div>
    <div class="line"></div>
    <el-dialog
      title="设置备用密保手机号码"
      :visible.sync="SpareEncryptedCellphone"
      width="30%"
    >
      <el-input
        v-model="moblieModel2.mobile"
        placeholder="请设置 备用密保手机号码"
      ></el-input>
      <!-- <div class="input clearfix">
        <div class="fl">
          <el-input
            placeholder="请输入图片验证码"
            v-model="moblieModel2.captcha"
            clearable
          >
          </el-input>
        </div>
        <div class="fr">
          <img @click="getCapt()" class="codeImg" :src="url" alt="" />
        </div>
      </div> -->
      <div class="input clearfix">
        <div class="fl">
          <el-input
            placeholder="请输入短信验证码"
            v-model="moblieModel2.captcha"
            clearable
          >
          </el-input>
        </div>
        <div class="fr">
          <el-button class="get-imgcode" @click="getCode()"
            >获取短信验证码</el-button
          >
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="SpareEncryptedCellphone = false">取 消</el-button>
        <el-button type="primary" @click="changeCellphobe()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getCapt, getCode, bindingSpareMobilePhone } from "@/api";
import { erroralert, successalert } from "@/utils/alert";
import { mapState, mapActions } from "pinia";
import { useMainStore } from "@/store/piniaStore";
export default {
  computed: {
    ...mapState(useMainStore, {
      initProjectList: "getInitProject",
      userInfo: "getUserInfo",
    }),
  },
  data() {
    return {
      url: "",
      show_mobile: false,
      moblieModel2: {
        mobile: "",
        captcha_key: "",
        captcha: "",
        event: "changesparemobile",
      },
      SpareEncryptedCellphone: false,
      standbyCellphone: "",
    };
  },
  methods: {
    ...mapActions(useMainStore, ["updateUserInfo", "fetchAndSetUserInfo"]),
    changeCellphobe() {
      bindingSpareMobilePhone(this.moblieModel2).then((res) => {
        this.resData = res.data.data;
        if (res.data.code === 1) {
          //设置完密保手机号刷新用户数据
          this.fetchAndSetUserInfo();
          this.SpareEncryptedCellphone = false;
          //更新用户信息 待补充
        }
      });
    },
    getCode() {
      getCode(this.moblieModel2).then((res) => {
        if (res.data.code === 1) {
          successalert(res.data.msg);
        }
      });
    },
    getCapt() {
      getCapt().then((res) => {
        if (res.data.code == 1) {
          this.url = res.data.data.captcha;
          this.moblieModel2.captcha_key = res.data.data.key;
        }
      });
    },
    spareEncrypted() {
      this.SpareEncryptedCellphone = true;
    },
  },
  created() {
    // this.getCapt();
  },
  props: {
    // 流程
  },
};
</script>

<style scoped></style>
